import GatewayService from '../../GatewayService.js';
var feedback = new GatewayService('feedbacktwo');

var setScoreVisibility = function setScoreVisibility(userKey, unitKey, cardstackKey, scoreType, value) {
  var params = {
    userBusinessKey: userKey,
    unitBusinessKey: unitKey,
    cardstackBusinessKey: cardstackKey,
    scoreType: scoreType
  };
  return feedback.post('scoreVisibility', value, {
    params: params,
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

var setAutoScoreVisibility = function setAutoScoreVisibility(userKey, unitKey, cardstackKey, value) {
  var scoreType = 'auto';
  return setScoreVisibility(userKey, unitKey, cardstackKey, scoreType, value);
};

export default {
  setAutoScoreVisibility: setAutoScoreVisibility
};